import script from "./mealsOrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./mealsOrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./mealsOrderDetails.vue?vue&type=style&index=0&id=0e3f105a&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3f105a"]])

export default __exports__